// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, Analytics, isSupported } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAI1SvvXAf_rkuNZ9MLkaJ0bOn7trNoj6A",
    authDomain: "dinesh-portfolio-385fa.firebaseapp.com",
    projectId: "dinesh-portfolio-385fa",
    storageBucket: "dinesh-portfolio-385fa.firebasestorage.app",
    messagingSenderId: "139141564642",
    appId: "1:139141564642:web:ce6b09553334a2bef4f6bb",
    measurementId: "G-1EYT021VTC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let analytics: Analytics | undefined;
if (process.env.NODE_ENV === 'production') {
    isSupported().then((supported) => {
        if (supported) {
            analytics = getAnalytics(app);
            console.log("Firebase Analytics: SDK Initialized successfully");
            // Trigger a direct log to confirm it's working
            logEvent(analytics, 'debug_production_init', { status: 'success' });
        } else {
            console.warn("Firebase Analytics: Not supported in this browser (possible Ad-blocker)");
        }
    }).catch(err => {
        console.error("Firebase Analytics: Initialization Error", err);
    });
}

export { analytics, logEvent };